import { combineReducers } from "redux";

// Reducerを追加したら、ここに追加する。

// 共通
import confirmDialog from "redux/modules/confirmDialog";
import errorDialog from "redux/modules/errorDialog";
import messageDialog from "redux/modules/messageDialog";
import snackbar from "redux/modules/snackbar";
import header from "redux/modules/header";

import completeDialog from "redux/modules/completeDialog";
// 画面
import login from "redux/modules/login";
import customerList from "redux/modules/customerList";
import customerDetail from "redux/modules/customerDetail";
import adminList from "redux/modules/adminList";
import surveyList from "redux/modules/surveyList";
import surveyDetail from "redux/modules/surveyDetail";
import surveyProgress from "redux/modules/surveyProgress";
import createSurvey from "redux/modules/createSurvey";
import setupAttr from "redux/modules/setupAttr";
import sendResetPassword from "redux/modules/sendResetPassword";
import passwordReset from "redux/modules/passwordReset";
import passwordUpdate from "redux/modules/passwordUpdate";
import surveyCheckWord from "redux/modules/surveyCheckWord";
import report from "redux/modules/report";
import reportDetail from "redux/modules/reportDetail";
import basicReport from "redux/modules/basicReport";
import originalReport from "redux/modules/originalReport";
import resultIndexReport from "redux/modules/resultIndexReport";
import freeOpinionReport from "redux/modules/freeOpinionReport";

// 担当者
import customerAdminSetting from "redux/modules/customerAdminSetting";

// 回答画面
import answerLogin from "redux/modules/answer/answerLogin";
import answerHeader from "redux/modules/answer/answerHeader";
import answerStart from "redux/modules/answer/answerStart";
import attributeReady from "redux/modules/answer/attributeReady";
import answerAttribute from "redux/modules/answer/answerAttribute";
import answerQuestion from "redux/modules/answer/answerQuestion";
import answerOther from "redux/modules/answer/answerOther";
import answerResult from "redux/modules/answer/answerResult";

// 部品
import customerModal from "redux/modules/customerModal";
import linerProgress from "redux/modules/linerProgress";
import employeeMaster from "./modules/empolyeeMaster";

const reducers = combineReducers({
  // 共通
  confirmDialog,
  errorDialog,
  messageDialog,
  snackbar,
  header,
  // 画面
  passwordReset,
  passwordUpdate,
  sendResetPassword,
  login,
  customerList,
  customerDetail,
  adminList,
  surveyList,
  surveyDetail,
  surveyProgress,
  createSurvey,
  setupAttr,
  surveyCheckWord,
  report,
  reportDetail,
  basicReport,
  originalReport,
  resultIndexReport,
  freeOpinionReport,
  // 担当者画面
  customerAdminSetting,
  // 回答画面
  answerLogin,
  answerHeader,
  answerStart,
  attributeReady,
  answerAttribute,
  answerQuestion,
  answerOther,
  answerResult,
  // 部品
  customerModal,
  linerProgress,
  completeDialog,
  employeeMaster
});

export default reducers;



// WEBPACK FOOTER //
// ./src/redux/reducers.js